<template>
  <div class="page">
    <f7-navbar v-bind:title="searchTerm" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="page-content">
      <header>
        <div class="course-content">
          <f7-row>
            <div
              class="avatar"
            ></div>
            <div class="name">
              <h3>{{ name }}</h3>
              <!--
              <p>
                <span>選課代碼 21004</span>
                <span>・</span>
                <span>課程代號 1131</span>
              </p>
              -->
            </div>
          </f7-row>
        </div>
      </header>
      <div class="wave-header sticky-top"></div>

      <!-- 學生的 -->
      <template v-if="!isCourseLoading">

        <template v-if="!captionFlag">
          <div class="list medium-detail-content">
            <ul>
              <li class="item-content">
                <p class="item-inner">{{ introduce }}</p>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">對應輔導科目</div>
                    <div class="item-input-wrap">
                      <select name="gender" id="gender" v-if="courseflag">
                        <option value="0" selected disabled>請選擇</option>
                        <template v-for="(item,index) in courseList">
                          <option v-bind:value="item.code">{{ item.name }}</option>
                        </template>
                        
                        <!--
                        <option value="a-la">阿拉伯語</option>
                        <option value="english">英語</option>
                        -->
                      </select>
                      <i class="material-icons arrow-down">arrow_drop_down</i>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            
            <f7-button class="button-large " v-bind:class="{ disabled: btnSend }" @click="openPrompt()">{{btnText}}</f7-button>
          </div>
        </template>
        <template v-else>
          <div class="list medium-detail-content">
            <ul>
              <li class="item-content">
                <p class="item-inner"></p>
              </li>
            </ul>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="content-loading"></div>
      </template>
    </div>
  </div>
</template>

<script>
import Service from "../../../service";
import PopModalTest from "./PopModalTest";
import PopErrorModal from "./PopErrorModal";
import PopErrorChoose from "./PopErrorChoose";
import PopNoThisClass from "./PopNoThisClass";
import axios from '../../../js/axiosModule';
import { bus } from '../../../js/bus';

var moment = require('moment');
export default {
  components: {},
  data() {
    return {
      title: "弹框测试页面",
      name:this.$store.state.userInfo.chineseName,
      checked: true,
      applyStudentNo:'',
      courseValue:'',
      introduce:'',
      courseList:[],
      courseflag:false,
      applySetYear:'',
      applySetTerm:'',
      applyTutor:'',
      applyNote:'',
      chineseName:'',
      applyCourseEndAt:'',
      searchTerm:'',
      isCourseLoading : false,
      caption : "",
      captionFlag :false,
      axiosFlag:false,
      btnSend: false,
      btnText:'送出申請'
    };
  },

  created: function() {},
  mounted() {},
  methods: {
    openPrompt: function() {
      
      this.applyCoachApplyCourse();

    },
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    },
    applyCoachApplyCourse: function() {
      let self = this;
      
      this.btnSend = true;
      this.btnText = "資料送出中．．．";
      
      var selectDom = document.getElementById("gender");
      if (selectDom.options[selectDom.selectedIndex].value != 0) {
          var params ={};
          params.id = 0;
          params.setYear = self.applySetYear;
          params.setTerm = self.applySetTerm;
          params.tutor = self.applyStudentNo;
          params.tutee = self.$store.state.userInfo.studentNo;
          params.courseCode = selectDom.options[selectDom.selectedIndex].value;
          params.courseName = selectDom.options[selectDom.selectedIndex].text;;
          params.applyStatus = 10;
          params.courseEndAt = self.applyCourseEndAt;
          params.note = "";
          params.searchTerm = self.searchTerm;
          params.createdBy = self.$store.state.userInfo.studentNo;
          params.createdAt = self.getNowTime();
          params.updatedBy = self.$store.state.userInfo.studentNo;
          params.updatedAt = self.getNowTime();

          axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/AddCoachApplyCourse",params).then((response)=> {
          // console.dir(response);
            if(response.data.status == 200) {
              window.localStorage.setItem("transferKey","mergeKey");
              self.$dialog.modal({
                component: PopModalTest,
                title: "",
                //showCloseBtn: this.checked,
                params: { firstInput: "" },

                callback: p => {
                  //self.$dialog.alert("已送出", { type: "success", showIcon: false });
                // self.$f7router.navigate("/coin-detail");
                // console.log("infor");


                }
              });
            } else  {
              self.$dialog.modal({
                component: PopErrorModal,
                title: "",
                //showCloseBtn: this.checked,
                params: { firstInput: "" },

                callback: p => {
                  //self.$dialog.alert("已送出", { type: "success", showIcon: false });
                  //self.$f7router.navigate("/coin-detail");
                }
              });
            }
          }).catch(err=>function() {
            if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
              self.$f7router.navigate("/login");
            } 
          });
      } else {
        self.$dialog.modal({
                component: PopErrorChoose,
                title: "",
                //showCloseBtn: this.checked,
                params: { firstInput: "" },

                callback: p => {
                  //self.$dialog.alert("已送出", { type: "success", showIcon: false });
                  //self.$f7router.navigate("/coin-detail");
                }
              });
      }
      
    },
    getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      
      var dateTime = moment(date+' '+time,"YYYY-MM-DD HH:mm:ss")._d;
      return new Date(dateTime);
    },
    setCourseValue: function() {

      let self = this;

      self.isCourseLoading = true;
      self.courseflag = false;
      var params = {};
      params.queryType = "studentno";
      params.queryString=self.$store.state.userInfo.studentNo;
      params.coachType=10;
      params.activeTime=self.getNowTime();
      params.canSearch = true;
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachStudent",params).then((response)=> {
         console.log(response);
          var respData = response.data.data;
        //  console.log(respData);
          if (respData == null &&  self.axiosFlag == false) {
            // self.caption = response.data.catpion;
            self.axiosFlag = true;
              self.captionFlag = true;
              self.isCourseLoading = false;
          
              self.$dialog.modal({
                    component: PopNoThisClass,
                    title: "",
                    //showCloseBtn: this.checked,
                    params: { firstInput: "" },

                    callback: p => {
                      //self.$dialog.alert("已送出", { type: "success", showIcon: false });
                      //self.$f7router.navigate("/coin-detail");
                    }
                  });
          } else {
              self.courseValue = respData.setYear+"-"+respData.setTerm+"-"+respData.studentNo;
              self.applySetYear=respData.setYear;
              self.applySetTerm=respData.setTerm;
              self.applyTutor=respData.applyStudentNo;
              self.applyNote="";
              self.applyCourseEndAt = respData.endAt;
              self.courseflag = true;
              self.getCourseList();
              self.captionFlag = false;
          }
     
       
        
        
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    },
    getCourseList: function() {

      let self = this;
      
       self.courseflag = false;
      var params = {};
      params.job = "selelist";
      params.filter = "yearterm";
      params.value = self.courseValue;
      //console.dir(params);
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/ThuApi/GetSelectCourseList",params).then((response) => {
      // console.dir(response);
        self.courseList = response.data.data;
        self.courseflag = true;

        self.isCourseLoading = false;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    }

  },created(){
      let self = this;
      bus.$on('applyBus',function(res){
        //console.log(res);
        self.introduce = res.introduce;
        self.chineseName = res.chineseName;
        self.applyStudentNo = res.applyStudentNo;
        self.searchTerm = res.searchTerm;
       self.setCourseValue();
      });
  } 
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling-apply/counseling-apply.vue